import { Badge } from './ui/badge';
import { fmtUsd, fmtPrice } from '../lib/numfmt';
import { Check } from 'lucide-react';

/**
 * DexScreener/DexTools-style selectable pool list. `selected` is a pair_address.
 */
export default function PoolList({ pools = [], selected, onSelect }) {
  if (!pools.length) {
    return (
      <div className="border border-dashed border-border p-8 text-center text-sm text-muted-foreground" data-testid="pool-list-empty">
        No live pools with liquidity found for this token.
      </div>
    );
  }
  return (
    <div className="border border-border overflow-hidden" data-testid="pool-list">
      <div className="grid grid-cols-[1.4fr_0.8fr_1fr_1fr_1fr] gap-2 px-3 py-2 bg-muted/40 mono-label text-[10px] border-b border-border">
        <span>Pair</span>
        <span>DEX</span>
        <span className="text-right">Liquidity</span>
        <span className="text-right">Price</span>
        <span className="text-right">Vol 24h</span>
      </div>
      <div className="divide-y divide-border max-h-[320px] overflow-y-auto">
        {pools.map((p) => {
          const active = selected === p.pair_address;
          return (
            <button
              key={p.pair_address}
              onClick={() => onSelect?.(p)}
              data-testid={`pool-row-${p.pair_address}`}
              className={`w-full grid grid-cols-[1.4fr_0.8fr_1fr_1fr_1fr] gap-2 px-3 py-2.5 text-sm items-center text-left transition-colors ${
                active ? 'bg-primary/10 border-l-2 border-primary' : 'hover:bg-accent border-l-2 border-transparent'
              }`}
            >
              <span className="font-semibold flex items-center gap-1.5 min-w-0">
                {active && <Check className="w-3.5 h-3.5 text-primary shrink-0" />}
                <span className="truncate">{p.base_symbol}/{p.quote_symbol}</span>
              </span>
              <span>
                <Badge variant="outline" className="text-[10px] px-1.5 py-0 truncate max-w-full">
                  {p.version || p.dex || '—'}
                </Badge>
              </span>
              <span className="text-right font-mono">{fmtUsd(p.liquidity_usd)}</span>
              <span className="text-right font-mono">{fmtPrice(p.price_usd)}</span>
              <span className="text-right font-mono text-muted-foreground">
                {p.volume_24h == null ? '—' : fmtUsd(p.volume_24h)}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
